import ga from 'react-ga'
import c from 'state/constants'

const filter = [
	c.LOG_IN, c.LOGGED_OUT, c.ITEM_ZOOMED, c.TOGGLE_MENU, c.MEDIA_CHANGED,
]

export default store => next => action => {
	if (filter.indexOf(action.type) >= 0) {
		ga.event({category: 'Actions',
			action: JSON.stringify(action),
		})
	}

	const result = next(action)
	return result
}



// WEBPACK FOOTER //
// ./state/gaMiddleware.js